const testimonials = document.querySelectorAll('.testimonial-modals-data')
testimonials.forEach( testimonial => {
	data = JSON.parse( testimonial.dataset.modals );
	data.forEach( modal => {
		var modalDiv = document.createElement('div');
		modalDiv.classList.add('modal', 'modal-xl', 'fade', 'testimonial-modal');
		modalDiv.setAttribute( 'id', modal.id );
		modalDiv.setAttribute( 'tabindex', -1 );
		modalDiv.setAttribute( 'aria-labelledby', 'TestimonialModalLabel' );
		modalDiv.setAttribute( 'aria-hidden', true );
		modalDiv.innerHTML += '<div class="modal-dialog"><div class="modal-content" data-object-type="testimonial">' + modal.modal_body + '</div></div>';
		document.body.appendChild(modalDiv);
	})
	modalDivs = document.querySelectorAll('.modal.testimonial-modal');
	modalDivs.forEach( modalDiv => {
		if( modalDiv.previousSibling && modalDiv.previousSibling.classList.contains('testimonial-modal') ){
			const prevButton = modalDiv.querySelector('.modal-previous-card');
			prevButton.setAttribute( 'data-bs-target', '#' + modalDiv.previousSibling.id );
			prevButton.classList.remove('card-modal-nav-invisible');
			prevButton.classList.add('card-modal-nav');
		}
		if( modalDiv.nextSibling && modalDiv.nextSibling.classList.contains('testimonial-modal') ){
			const nextButton = modalDiv.querySelector('.modal-next-card');
			nextButton.setAttribute( 'data-bs-target', '#' + modalDiv.nextSibling.id );
			nextButton.classList.remove('card-modal-nav-invisible');
			nextButton.classList.add('card-modal-nav');
		}
	})
});
